<template>
  <div>
    <transition name="fade">
      <div class="pae-modal" v-if="show">
        <div class="pae-modal__backdrop" @click="closeModal()"/>

        <div class="pae-modal__dialog" :style="dialogStyle">
          <div>
            <slot name="header"/>
          </div>

          <div class="pae-modal__body">
            <slot name="body"/>
          </div>

          <div class="pae-modal__footer">
            <slot name="footer"/>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'

export default {
  name: 'Modal',
  data () {
    return {
      show: false
    }
  },

  props: {
    eventBusModal: { type: String, required: false, default: '' },
    width: { type: String, required: false, default: '800px' },
    height: { type: String, required: false, default: '650px' }
  },

  methods: {
    closeModal () {
      this.show = false
      eventBus.$emit(this.eventBusModal)
      document.querySelector('body').classList.remove('overflow-hidden')
    },

    openModal () {
      this.show = true
      document.querySelector('body').classList.add('overflow-hidden')
    }
  },

  computed: {
    dialogStyle () {
      return `max-width: ${this.width}; height: ${this.height};`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/estiloGlobal.scss";

.pae-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  overflow-x: hidden;
  overflow-y: auto;

  &__backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: $bodyPage_openModal_backgroud;
    z-index: 1;
  }

  &__dialog {
    position: relative;
    background-color: $modal_dialog_backgroud;
    border-radius: 5px;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    z-index: 2;

    @media screen and (max-width: 992px) {
      width: 90%;
    }
  }

  &__body {
    padding: 10px 20px 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
}

</style>
